
import { ISelectChoice } from './SelectCommons';
import EDListItemText from '../List/Components/EDListItemText';
import EDTypography from '../Typography/EDTypography';
import { equals } from 'ramda';
import EDBox from '../EDBox/EDBox';

interface IProps<T> {
  item: ISelectChoice<T>;
  onChange: (item: T) => void;
  currentValue?: T;
}

const EDSelectMenuItem: <T>(
  props: IProps<T>
) => React.ReactElement<IProps<T>> = props => {
  const { item } = props;

  const onChange = () => {
    props.onChange(item.value);
  };

  return (
    <EDBox
      sx={{
        width: '100%',
      }}
      onClick={onChange}
    >
      <EDListItemText
        primary={
          <EDTypography
            color="textPrimary"
            bold={equals(item.value, props.currentValue)}
          >
            {item.header}
          </EDTypography>
        }
        secondary={
          <EDTypography color="textPrimary" component="span">
            {item.subHeader}
          </EDTypography>
        }
        noLeftPadding
      />
    </EDBox>
  );
};

export default EDSelectMenuItem;
